/**
 * Task Section Component
 *
 * Displays non-harvest task analytics with worker completions
 */

import React from 'react'
import type { TaskType, Worker } from 'src/store/todo/types'

type WorkerTaskData = {
  worker: Worker
  completedLocations: number
}

type TaskSectionProps = {
  /** Task type */
  task: TaskType
  /** Total completed locations for this task */
  taskTotalCompleted: number
  /** Array of worker task data */
  workersForTask: WorkerTaskData[]
}

/**
 * TaskSection component showing task completion statistics
 *
 * @example
 * <TaskSection
 *   task={taskType}
 *   taskTotalCompleted={25}
 *   workersForTask={workerData}
 * />
 */
const TaskSection: React.FC<TaskSectionProps> = ({
  task,
  taskTotalCompleted,
  workersForTask,
}) => {
  if (workersForTask.length === 0) return null

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4">
      <h3 className="font-semibold text-gray-900 mb-2">
        {task.taskType} ({taskTotalCompleted})
      </h3>
      <div className="space-y-1">
        {workersForTask.map((data) => (
          <div
            key={data.worker.id}
            className="flex items-center justify-between px-2 py-1 bg-gray-50 rounded text-sm"
          >
            <span className="font-medium text-gray-900">
              {data.worker.firstName} {data.worker.lastName}
            </span>
            <span className="font-semibold text-gray-900">{data.completedLocations}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TaskSection
